export const generateDLN = (lastName, DOB, gender) => {
  if (!lastName || !DOB || !gender) return "";

  lastName = lastName.replace(/\s/g, "").toUpperCase();

  // Handle last name length
  let first5chars =
    lastName.length > 4 ? lastName.substring(0, 5) : lastName.padEnd(5, "9");

  const char6 = DOB.substring(8, 9); // Extracts the 9th character (D from DD-MM-YYYY)

  let chars78 = DOB.substring(3, 5); // Month MM
  if (gender !== "Male") {
    chars78 = (parseInt(chars78, 10) + 50).toString().padStart(2, "0");
  }

  const chars910 = DOB.substring(0, 2); // Day DD
  const char11 = DOB.substring(9, 10); // Extracts 10th character (last digit of YYYY)

  return `${first5chars}${char6}${chars78}${chars910}${char11}`;
};
